import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  effect,
  HostListener,
  inject,
  OnChanges,
  OnInit,
  Renderer2,
  signal,
  SimpleChanges,
  TemplateRef,
  WritableSignal
} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {SecurityService} from "../../../security/security.service";
import {CommonModule} from "@angular/common";
import {FeatherModule} from "angular-feather";
import {SharedCommonModule} from "../../../shared/commons/shared-common.module";
import {LoadingComponent} from "../../../shared/commons/loader/loading.component";
import {notImplementedYet} from "../../../app.constants";
import {FormsModule} from "@angular/forms";
import {UserData} from "../../../../generated-model/model";
import {environment} from "../../../../environments/environment";
import {HasAnyAuthorityDirective} from "../../../security/has-any-authority.directive";
import {SwitchUserModalService} from "../switch-user-modal/switch-user-modal.service";
import {NgbOffcanvas, OffcanvasDismissReasons} from "@ng-bootstrap/ng-bootstrap";
import {NavCollapseDirective} from "../../../shared/commons/nav-collapse.directive";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {HttpClient, HttpContext} from "@angular/common/http";
import {IGNORE_LOADING} from "../../../interceptors/loading_interceptor";
import {IGNORE_400_ERROR} from "../../../shared/commons/interceptor/http400-interceptor";
import {IGNORE_5XX_ERROR} from "../../../shared/commons/interceptor/http5xx-interceptor";

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    RouterOutlet,
    FeatherModule,
    RouterLinkActive,
    SharedCommonModule,
    LoadingComponent,
    HasAnyAuthorityDirective,
    NavCollapseDirective
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, AfterViewInit, AfterViewChecked, OnChanges {
  environment = environment
  principal?: (UserData & { name?: string });
  authenService = inject(SecurityService);
  renderer = inject(Renderer2);
  protected readonly notImplementedYet = notImplementedYet;
  selectedFontSize: '14px' | '16px' | '18px' = '14px';
  rightSearchCollapsed = false;
  switchUserModalService = inject(SwitchUserModalService);
  toggleOffCanvas = false;
  isSidebarCollapsed = false;
  private offcanvasService = inject(NgbOffcanvas);
  closeResult: WritableSignal<string> = signal('');
  // isTestEnv = signal(!isDevMode() && environment.production === false);
  isTestEnv = signal(environment.test);
  private oidcSecurityService  = inject(OidcSecurityService);
  private http = inject(HttpClient);
  appVersion?: string;

  constructor() {
    effect(() => {
      this.calculateLayoutRatio();
    });
  }

  ngOnInit(): void {
    this.toggleOffCanvas = window.innerWidth < 992;
    this.isSidebarCollapsed = window.innerWidth < 992;
    this.authenService.user$()
      .subscribe((value: any) => {
        this.principal = value;
      });
    this.loadAppVersion();
  }

  private loadAppVersion(): void {
    // Maven ${project.version} is published at /public/api/version (build.version) by the
    // spring-boot build-info goal. After a release it carries the release version (e.g. 0.0.1).
    const context = new HttpContext()
      .set(IGNORE_LOADING, true)
      .set(IGNORE_400_ERROR, true)
      .set(IGNORE_5XX_ERROR, true);
    this.http.get<{ build?: { version?: string } }>(`${environment.serverUrl}/public/api/version`, {context})
      .subscribe({
        next: info => this.appVersion = info?.build?.version,
        error: () => { /* version readout is best-effort; ignore failures */ }
      });
  }

  ngAfterViewInit(): void {
    this.calculateLayoutRatio();
  }

  ngAfterViewChecked(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
  }

  openSidebarOffcanvas(content: TemplateRef<any>) {
    this.offcanvasService.open(content, {ariaLabelledBy: 'offcanvas-basic-title'}).result.then(
      (result) => {
        this.closeResult.set(`Closed with: ${result}`);
      },
      (reason) => {
        this.closeResult.set(`Dismissed ${this.getDismissReason(reason)}`);
      },
    );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case OffcanvasDismissReasons.ESC:
        return 'by pressing ESC';
      case OffcanvasDismissReasons.BACKDROP_CLICK:
        return 'by clicking on the backdrop';
      default:
        return `with: ${reason}`;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // 1024px is break point of large devices
    console.log('window:resize');
    this.calculateLayoutRatio();
    // 992px is break point of large devices
    this.toggleOffCanvas = event.target.innerWidth < 992;
    this.isSidebarCollapsed = event.target.innerWidth < 992;
  }

  calculateLayoutRatio() {
    // let sidebar = document.getElementById("sidebar");
    // let content = document.getElementById("content");
    // if (this.toggleSidebar()) {
    //   content.style.width = `calc(100% - 300px);`;
    // } else {
    //   content.style.width = '100%;'
    // }
  }

  logout() {
    this.authenService.logout();
    // this.http.post(`${environment.serverUrl}/logout`, {})
    //   .subscribe();
  }

  setFontSizeTo(fontSize: string) {
    this.renderer.setAttribute(document.querySelector('body'), 'data-default-font-size', fontSize);
  }

  profile() {
    window.location.href = `${environment.profileUrl}?referrer=${environment.clientId}`;
  }

  switchUser() {
    this.oidcSecurityService.logoffLocal()
    window.location.href = `${this.environment.srmPortalUrl}/secure/switch-user?redirect_url=${encodeURI(`${this.environment.serverUrl}`)}`;
  }

  protected readonly open = open;
}
